import { ButtonTriggerEvent } from '../../../../common/components';
import { Account } from '../../../../models/admin/account';

export class TravelBuddySettingsModalActions {
  confirm: (event: ButtonTriggerEvent) => void;
  cancel?: () => void;
}

export class TravelBuddySettingsModalData {
  account: Account;
  constructor(account?) {
    this.account = account;
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/admin/accounts/travel.buddy.settings/travel.buddy.settings.modal.provider.ts